import "./Cart.module.css";
import EstateHeader from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import EstateFooter from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <EstateHeader />
      <CartContent />
      <EstateFooter />
    </div>;
}